import { h } from './index-16dc7dde.js';

const PesProductLink = ({ url, id, className, enableAppRouting, tabId }, children) => {
  let props = {
    page: 'product',
    pageId: id,
    className,
    tabId,
  };
  if (!enableAppRouting) {
    props = Object.assign(Object.assign({}, props), { url });
  }
  return h("pes-router-link", Object.assign({}, props), children);
};

export { PesProductLink as P };
